module.exports = __webpack_public_path__ + "img/BannerNew.7958df7b.png";